export function ajax(settings) {
  return $.ajax(settings);
}
